// extracted by mini-css-extract-plugin
module.exports = {"label":"Label_label__v6roG","mobile":"Label_mobile__DW3n5"};